import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ pokemon }) => {
    return (
        <li className='card'>
            <Link to={`/pokemon/${pokemon.pokedex_id}`}>
                <img src={pokemon.sprites.regular} alt="pokemon" />
                <div className="infos">
                    <h2>Nº {pokemon.pokedex_id}</h2>
                    <h2>{pokemon.name.fr}</h2>
                </div>
            </Link>
        </li>
    );
};

export default Card;